module.exports = __webpack_public_path__ + "_assets/img/profile-06.02e2949d.svg";